import { ValueObject } from '@nx-smartmonkey/shared/domain';

type InvoiceStatus = `open` | `uncollectible` | `paid` | `void`;

export interface SubscriptionInvoiceProps {
  id: number;
  bill_number: string;
  date: Date;
  invoice_pdf: string;
  amount: number;
  status: InvoiceStatus;
}

export class SubscriptionInvoice extends ValueObject<SubscriptionInvoiceProps> {
  get id(): number {
    return this.props.id;
  }

  get bill_number(): string {
    return this.props.bill_number;
  }

  get date(): Date {
    return this.props.date;
  }

  get invoice_pdf(): string {
    return this.props.invoice_pdf;
  }

  get amount(): number {
    return this.props.amount;
  }

  get status(): string {
    return this.props.status;
  }

  private constructor(props: SubscriptionInvoiceProps) {
    super(props);
  }

  static create(props: SubscriptionInvoiceProps): SubscriptionInvoice {
    return new SubscriptionInvoice(props);
  }
}
